import { NotificationDto } from "@/hooks/services/workchestra/types/notification.type";
import { Notification } from "./types";

// RelatedObjectName(s) that represent Library (Technical Manual) notifications.
export const libraryRelatedObjectNames = ["TechnicalManualBorrow"];

// Map a UI notification category to the backend RelatedObjectName(s) used for filtering.
// Returns undefined for "all" (no filter) and falls back to [category] for unknown values.
export function getCategoryRelatedObjectNames(
  category: string,
): string[] | undefined {
  const normalized = category.trim().toLowerCase().replace(/\s+/g, "");
  if (normalized === "all") return undefined;

  const categoryMap: Record<string, string[]> = {
    workchestra: ["Account", "JobOrder", "AuthoredFormVersions"],
    csr: ["ECSR"],
    ecsr: ["ECSR"],
    eforms: ["UserGenericForm"],
    aerostaff: ["AeroTrakerCertification"],
    capmaster: ["CapMaster"],
    library: libraryRelatedObjectNames,
    technicalmanual: libraryRelatedObjectNames,
    technicalmanuals: libraryRelatedObjectNames,
    tool: ["IssuedToolList", "EquipmentCollection"],
    tools: ["IssuedToolList", "MissingToolReport", "EquipmentCollection"],
    issuedtoollist: ["IssuedToolList"],
    equipmentcollection: ["EquipmentCollection"],
  };

  return categoryMap[normalized] || [category];
}

// Map a backend NotificationDto to the frontend Notification type, deriving the
// display label and owning app from the relatedObjectName.
export function mapNotificationDto(dto: NotificationDto): Notification {
  const labelMap: Record<string, string> = {
    account: "Account",
    usergenericform: "eForm",
    joborder: "Job Order",
    authoredformversions: "CRR",
    aerotrakercertification: "Certification",
    capmaster: "Cap Master",
    technicalmanualborrow: "Library",
    issuedtoollist: "Tools",
    equipmentcollection: "Tools",
  };

  const appMap: Record<string, string> = {
    aerotrakercertification: "AeroStaff",
    capmaster: "Cap Master",
    technicalmanualborrow: "Library",
    issuedtoollist: "Tool",
    equipmentcollection: "Tool",
  };

  const relatedObjectName = dto.relatedObjectName?.toLowerCase() || "";

  return {
    id: dto.id,
    title: dto.title,
    description: dto.message,
    notificationType: dto.notificationType,
    actionText: "View Details",
    actionLink: dto.redirectUrl || "#",
    label: labelMap[relatedObjectName] || dto.relatedObjectName || "",
    isRead: dto.isRead,
    createdAt: new Date(dto.createdOn),
    app: appMap[relatedObjectName] || "Other",
  };
}
